module.exports = __webpack_public_path__ + "static/media/number-3-normal.a8aaab1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/numbers/number-3-normal.svg
// module id = 1310
// module chunks = 0